<template>
  <main class="page content" :class="!loading ? '' : 'loading'">
    <not-found v-if="notFound"></not-found>
    <div v-if="currentPost && currentPost.publishStatus === 'publish'">
      <episode :episode="currentPost" v-if="currentPost.postType === 'episode'"></episode>
      <extra :extra="currentPost" v-if="currentPost.postType === 'extra'"></extra>
      <page :page="currentPost" v-if="currentPost.postType === 'page'"></page>
    </div>
  </main>
</template>

<script>
import Episode from './Episode'
import Extra from './Extra'
import Page from './Page'
import NotFound from './NotFound'

import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'post',
  data () {
    return {
      notFound: false,
      loading: true
    }
  },
  components: {
    Episode,
    Extra,
    Page,
    NotFound
  },
  mounted () {
    this.fetchPost()
  },
  methods: {
    fetchPost () {
      let vm = this
      // GET /posts => get_single_post() [theme-folder]/api/functions.php
      vm.$axios.get('/posts', {
        params: {
          slug: vm.$route.params.slug
        }
      })
      .then((response) => {
        vm.loading = false
        if (response.data) {
          vm.setCurrentPost(response.data)
          if (vm.nonce && (vm.$route.query.preview === 'true')) {
            vm.$router.push({ name: 'Preview', query: { preview_id: response.data.id } })
          } else if (vm.$route.hash) {
            vm.scrollToAnchor()
          }
        } else {
          vm.notFound = true
        }
      })
      .catch((err) => {
        vm.loading = false
        vm.notFound = true
        console.log(err)
      })
    },
    scrollToAnchor () {
      let id = this.$route.hash.replace('#', '')
      process.nextTick(() => {
        document.getElementById(id).scrollIntoView()
      })
    },
    ...mapActions([
      'setCurrentPost'
    ])
  },
  computed: {
    nonce () {
      if (window.wpApiSettings && window.wpApiSettings.nonce) {
        return window.wpApiSettings.nonce
      }
    },
    ...mapGetters([
      'currentPost'
    ])
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>



// WEBPACK FOOTER //
// Post.vue?324b85d2